import React from "react";
import Button from "../../../../../../components/Common/Button/Button";
import ClassCard from "../../../../../../components/Common/ClassCard/ClassCard";
import Input from "../../../../../../components/Common/Input/Input";
import SeriesCard from "../../../../../../components/Common/SeriesCard/SeriesCard";
import { useSelector } from "react-redux";
import classes from "./CardContainer.module.scss";
import { FormattedMessage } from "react-intl";
import FrequencyDropdown from "../../../FrequencyDropdown/FrequencyDropdown";

const CardContainer = ({
  data,
  handleDelete,
  repititiveValArr,
  onSelectChange,
  radioBtnVal,
  onRadioChange,
  onSaveClick,
  id,
  dropDownName,
  radioBtnName,
  radioBtnFieldName,
  isDelete,
  selectedRadioBtnVal,
  buttonLoader,
  selectVal,
  imageClick,
  selectedRepetitveVal,
}) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;

  return (
    <div className={classes.card} key={id}>
      {selectVal === "Classes" ? (
        <ClassCard
          handleDelete={() => handleDelete(data?.ID, data?.Name)}
          isDeleteVisible={isDelete}
          shotClassData={data}
        />
      ) : (
        <SeriesCard
          seriesData={data}
          imageClick={() => imageClick(data?.Programs?.ID)}
          isDeleteVisible={isDelete}
          handleDelete={() =>
            handleDelete(data?.Programs?.ID, data?.Programs?.Name)
          }
        />
      )}
      <div className={classes.details}>
        <div className={classes.priority}>
          <div className={classes.text}>Change Priority</div>
          {(!selectedRadioBtnVal &&
            (data?.radioBtnVal === radioBtnVal[1] || data?.IsRepetitive)) ||
          selectedRadioBtnVal === radioBtnVal[1] ? (
            // <Input
            //   name={dropDownName}
            //   fieldName="val"
            //   type="select"
            //   labelColor="light"
            //   width="10"
            //   height="2.9"
            //   valueArr={repititiveValArr}
            //   onChange={onSelectChange}
            // />
            <FrequencyDropdown
              valueArr={repititiveValArr}
              onSelectChange={onSelectChange}
              frequencyVal={
                data?.selectedDropdownVal
                  ? data?.selectedDropdownVal
                  : data?.FrequencyName
              }
              shotclassId={data?.ID}
            />
          ) : (
            <></>
          )}
        </div>
        <div className={classes.radiobtns}>
          {radioBtnVal.map((val, index) => {
            return (
              <Input
                label={val}
                name={`${radioBtnName}`}
                fieldName={`${radioBtnFieldName}${index}`}
                value={val}
                type="radio"
                labelColor="dark"
                direction="row-reverse"
                width="2"
                height="2"
                key={val}
                onChange={(e) =>
                  onRadioChange(e, data?.ID, data?.FrequencyName)
                }
                disableLabelClick
              />
            );
          })}
          <Button
            label={<FormattedMessage id="P_SAVE_TXT" />}
            isHover
            borderRadius="2"
            width="8"
            height="3"
            color="#404040"
            light
            hoverColor={colors.theme}
            onClick={() => {
              onSaveClick(data);
            }}
            backgroundColor={buttonLoader ? undefined : "#D31B61"}
            loading={buttonLoader}
          />
        </div>
      </div>
    </div>
  );
};

export default CardContainer;
